export default function SidebarMenuLabel() {
  return (
    <p className="mb-4 px-4 text-xs font-semibold uppercase tracking-wider text-teal-200">
      Menu Principal
    </p>
  );
}
